// HeroSection organism component
import { Heading, Text, Button } from "../atoms";
import { scrollToSection } from "../../utils/scroll";
import { useLandingContent } from "../../contexts/LandingContentContext";
import { resolveImageUrl } from "../../utils/imageUrl";

export const HeroSection = ({ donationEnabled = true }) => {
  const { hero } = useLandingContent();

  return (
    <section
      id="home"
      className={`relative overflow-hidden ${hero.backgroundImage ? "bg-cover bg-center" : "bg-gradient-to-br from-paper via-cream to-terracotta-50"} pt-36 pb-28 text-center`}
      style={
        hero.backgroundImage
          ? { backgroundImage: `url(${resolveImageUrl(hero.backgroundImage)})` }
          : undefined
      }
    >
      {hero.backgroundImage && (
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 bg-black/30"
        />
      )}
      {!hero.backgroundImage && (
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 opacity-20"
          style={{
            backgroundImage:
              "radial-gradient(ellipse 80% 60% at 50% 0%, #c2513a33 0%, transparent 70%)",
          }}
        />
      )}

      <div className="relative max-w-3xl mx-auto px-6">
        {/* Eyebrow label */}
        <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-terracotta-200 bg-terracotta-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-terracotta-700">
          {hero.eyebrow}
        </p>

        {/* Main headline */}
        <Heading
          level={1}
          className="font-display text-ink mb-6 text-4xl leading-tight sm:text-5xl lg:text-6xl"
        >
          {hero.headlinePre}
          <span className="text-terracotta-600">{hero.headlineAccent}</span>
          {hero.headlinePost}
        </Heading>

        {/* Sub-copy */}
        <Text
          size="xl"
          className="text-ink-soft mb-10 max-w-xl mx-auto leading-relaxed"
        >
          {hero.subCopy}
        </Text>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          {(donationEnabled || hero.primaryCta.target !== "donate") && (
            <Button
              variant="cta"
              onClick={() => scrollToSection(hero.primaryCta.target)}
              className="px-10 py-4 rounded-full text-base font-semibold shadow-lift hover:shadow-soft transition-shadow duration-200"
            >
              {hero.primaryCta.label}
            </Button>
          )}
          {(donationEnabled || hero.secondaryCta.target !== "donate") && (
          <button
            onClick={() => scrollToSection(hero.secondaryCta.target)}
            className="text-sm font-medium text-terracotta-700 underline underline-offset-4 hover:text-terracotta-900 transition-colors duration-200"
          >
            {hero.secondaryCta.label}
          </button>
          )}
        </div>
      </div>

      {/* Bottom fade */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-paper to-transparent"
      />
    </section>
  );
};
